import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../../layouts/shared-service';
import { AuthService, DBService, DownLoadService } from '../../../service';
import { Router } from '@angular/router';
import { DropDownService } from '../../../service/drop-down.service';
import { StorageService } from '../../../service/storage.service';
import { User } from '../../../model/types';
import {AnalysisKey, AuthLog, Logs, PreviousAnalysis} from '../../../model/analysis-details.model';
import Utils from '../../../utility/Utils';
import { MatDatepicker } from '@angular/material/datepicker';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import _moment from 'moment';
import {default as _rollupMoment, Moment} from 'moment';
import { FormControl } from '@angular/forms';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector: 'app-audit-trail',
    templateUrl: './analysis-trail.component.html',
    styleUrls: ['./analysis-trail.component.scss'],
    providers: [{
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    standalone: false
})
export class AuditTrailComponent implements OnInit {
  date = new FormControl(moment());
  startDate;
  endDate;
  role;
  pageTitle = 'User Account';
  signedInUser: any;
  pageLoaded = false;
  previousAnalysisKeys: AnalysisKey[] = [];
  illegalUser: boolean;
  maxYear;
  title = 'Loading';
  @ViewChild('datePicker') public dp;

  constructor(private _sharedService: SharedService,
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router,
    private dbService: DBService,
    private dropDownService: DropDownService,
    private downloadService: DownLoadService) {
    this._sharedService.emitChange(this.pageTitle);
  }

  ngOnInit(): void {
    this.authService.getCurrentUser((err, user: User) => {
        this.signedInUser = user;
        if (!this.signedInUser || !this.signedInUser.signedIn) {
            this.router.navigate(['/extra-layout/signin']);
            return;
        } else {
            this.dbService.getAnalysis('audit');
        }
    });
    this.dbService.userSearch.subscribe(
        (data: AnalysisKey[]) => {
            this.previousAnalysisKeys = data;
            this.pageLoaded = true;
        }
    );
  }

  passSelectedDates() {
    this.previousAnalysisKeys = [];
    const data = this.dbService.getAnalysis('audit', this.startDate, this.endDate);
  }

  selectedDates(dateRangeStart, dateRangeEnd){
    this.startDate = dateRangeStart.value;
    this.endDate = dateRangeEnd.value;
    this.passSelectedDates();
  }
}


